import { useCallback, useRef } from 'react';

const useDebounceCallback = (
  callback: (...params: any) => void,
  timeout?: number,
) => {
  const debounceTimeout = useRef<NodeJS.Timeout>(null);
  const debouncedCallback = useCallback(
    (...params: any) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      if (timeout && timeout > 0) {
        debounceTimeout.current = setTimeout(
          () => callback(...params),
          timeout,
        );
      } else {
        callback(...params);
      }
    },
    [callback, timeout],
  );

  return debouncedCallback;
};

export default useDebounceCallback;
